import React, { useState, useEffect } from "react";
function Navbar({ setTap, tap, navbar, show }) {
  return (
    <div>
      <div
        className="dark:bg-gray-800"
        style={{
          height: "50px",
          backgroundColor: "rgb(48, 68, 94)",
          display: "flex",
          justifyContent: "space-around",
          position: "absolute",
          width: navbar ? "100%" : "40px",
          height: navbar ? "30px" : "100%",
          flexDirection: navbar ? "row" : "column",
          bottom: "0",
          borderRadius: navbar ? "0  0 30px 30px" : "24px 0px 0px 24px",
        }}
      >
        {show ? (
          <div
            className="tooltip"
            onClick={() => setTap("phone")}
            style={{
              margin: "auto",
              borderRadius: "5px",
              // width: "45px",
              cursor: "pointer",
            }}
          >
            <span class="tooltiptext">Clavier</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              style={{
                color: tap === "phone" ? "#21ba90" : "white",
                margin: "auto",
              }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>
            {/* <p
              style={{
                fontSize: "xx-small",
                color: "white",
                textAlign: "center",
              }}
            >
              Clavier
            </p> */}
          </div>
        ) : null}
        <div
          className="tooltip"
          onClick={() => setTap("logs")}
          style={{
            margin: "auto",
            borderRadius: "5px",
            // width: "47px",
            cursor: "pointer",
          }}
        >
          <span class="tooltiptext">Journal</span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            style={{
              color: tap === "logs" ? "#21ba90" : "white",
              margin: "auto",
            }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          {/* <p
            style={{
              fontSize: "xx-small",
              color: "white",
              textAlign: "center",
            }}
          >
            Journal
          </p> */}
        </div>

        <div
          className="tooltip"
          onClick={() => setTap("user")}
          style={{
            margin: "auto",
            borderRadius: "5px",
            // width: "47px",
            cursor: "pointer",
          }}
        >
          <span class="tooltiptext">Collègues</span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
            style={{
              color: tap === "user" ? "#21ba90" : "white",
              margin: "auto",
            }}
          >
            {" "}
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />{" "}
          </svg>
          {/* <p
            style={{
              fontSize: "xx-small",
              color: "white",
              textAlign: "center",
            }}
          >
            Collègues
          </p> */}
        </div>

        <div
          className="tooltip"
          onClick={() => setTap("contacts")}
          style={{
            margin: "auto",
            borderRadius: "5px",
            // width: "57px",
            cursor: "pointer",
          }}
        >
          <span class="tooltiptext">Contacts</span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1}
            style={{
              color: tap === "contacts" ? "#21ba90" : "white",
              margin: "auto",
            }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
            />
          </svg>
          {/* <p
            style={{
              fontSize: "xx-small",
              color: "white",
              textAlign: "center",
            }}
          >
            Contacts
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default Navbar;
